function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M9.529 10.471a.667.667 0 10.942-.942l-.942.942zM6.47 5.53a.667.667 0 10-.942.942l.942-.942zm4 .942a.667.667 0 10-.942-.942l.942.942zM5.53 9.53a.667.667 0 10.942.942L5.53 9.53zm4.942 0l-4-4-.942.942 4 4 .942-.942zm-.942-4l-4 4 .942.942 4-4-.942-.942zM14 8a6 6 0 01-6 6v1.333A7.333 7.333 0 0015.333 8H14zm-6 6a6 6 0 01-6-6H.667A7.333 7.333 0 008 15.333V14zM2 8a6 6 0 016-6V.667A7.333 7.333 0 00.667 8H2zm6-6a6 6 0 016 6h1.333A7.333 7.333 0 008 .667V2z",
  fill: "#FF7D7D"
});

var SvgBespokenIconFailed = function SvgBespokenIconFailed(props) {
  return React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none"
  }, props), _ref);
};

export default SvgBespokenIconFailed;